import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { clients as clientsApi } from "../api";
import NarrativeReader from "../components/NarrativeReader";

export default function ClientPastReports() {
  const { clientId } = useParams();
  const id = parseInt(clientId, 10);
  const [history, setHistory] = useState(null);
  const [selected, setSelected] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    clientsApi.narrativeHistory(id)
      .then((rows) => {
        setHistory(rows);
        setSelected(rows[0] || null);
      })
      .catch((e) => setErr(e?.response?.data?.detail || e.message));
  }, [id]);

  if (err) return <div className="page"><div className="error-box">{err}</div></div>;
  if (!history) return <div className="page"><p className="subtle">Loading…</p></div>;
  if (history.length === 0)
    return <div className="page"><div className="empty">No past reports yet.</div></div>;

  return (
    <div className="page">
      <div className="page-head">
        <div><h1>Past reports</h1></div>
      </div>

      <div className="split">
        <div className="card">
          {selected ? (
            <NarrativeReader narrative={selected.client_narrative} headline={selected.headline} />
          ) : <div className="empty">Pick a month.</div>}
        </div>
        <div className="card">
          <h2>Archive</h2>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {history.map((h) => (
              <li key={h.id}>
                <button
                  className={selected?.id === h.id ? "" : "ghost"}
                  style={{
                    width: "100%", textAlign: "left", padding: "10px 12px",
                    background: selected?.id === h.id ? "var(--accent-soft)" : "transparent",
                    color: "var(--ink)", marginBottom: 4, borderRadius: "var(--radius)",
                  }}
                  onClick={() => setSelected(h)}
                >
                  <strong>
                    {h.period_start ? new Date(h.period_start).toLocaleDateString("en-US", { month: "long", year: "numeric" }) : "Report"}
                  </strong>
                  {h.health_score != null && <span className="subtle"> — score {h.health_score}</span>}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
